import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';
import CreatePageConstants from '../../../CreatePageConstants';

const anchorPointOptions = CreatePageConstants.ANCHOR_POINT_OPTIONS;

const LyricsAnchorListItem = (props) => {
    const { lyricsAnchorPoint, updateLyricsStyle } = props;
    const onAnchorChange = (value) => updateLyricsStyle({ anchorPoint: value });
    
    return (
        <ToggleButtonListItem
            text='Anchor'
            value={lyricsAnchorPoint}
            onChange={onAnchorChange}
            options={anchorPointOptions}
        />
    );
};

const mapStateToProps = (state) => {
    const { anchorPoint: lyricsAnchorPoint } = state.createPreview.present.videoSettings.lyrics.style;
    return { lyricsAnchorPoint };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsAnchorListItem);